import { useApiClient } from '@/composables/useApiClient'
import { CategoryOnboard } from '@/view-models/category'

const getDefaultState = () => {
  return {
    category: {},
    categoryFaqs: [],
    subcategories: [],
    firstLevelCategory: {},
  }
}

export const state = () => getDefaultState()

export const getters = {
  category: state => state.category,
  categoryFaqs: state => state.categoryFaqs,
  subcategories: state => state.subcategories,
  firstLevelCategory: state => state.firstLevelCategory,
}

export const actions = {
  resetCategory({ commit }) {
    commit('SET_CATEGORY')
    commit('SET_FIRST_LEVEL_CATEGORY', {})
    commit('SET_SUBCATEGORIES', [])
  },
  setFirstLevelCategory({ commit }, category) {
    commit('SET_FIRST_LEVEL_CATEGORY', category)
  },
  async getCategory({ commit }, { categoryID, isFromSubcategory = false }) {
    const url = `/pub/category/${categoryID}`
    const res = await useApiClient().$get(url)
    if (res.code !== 0) {
      return
    }
    commit('SET_CATEGORY', res.data)
    if (!isFromSubcategory) {
      const subcategories = res.data.sub_categories.filter(c => c.web_onboard !== CategoryOnboard.Hidden)
      commit('SET_SUBCATEGORIES', subcategories)
    }
  },
  async getCategoryFaqs({ commit }, { regionID, categoryID }) {
    const url = `/pub/category/${categoryID}/faq`
    const res = await useApiClient().$get(url, { params: { region_id: regionID } })

    if (res.code === 0) {
      commit('SET_CATEGORY_FAQS', res.list)
    }
  },
  getBlogsArticle({ commit }, { blogID }) {
    const url = `/blogs/article/${blogID}`
    return useApiClient().$get(url)
  },
}

export const mutations = {
  RESET_CATEGORY(state) {
    Object.assign(state, getDefaultState())
  },
  SET_CATEGORY(state, payload) {
    state.category = payload
  },
  SET_CATEGORY_FAQS(state, payload) {
    state.categoryFaqs = payload
  },
  SET_SUBCATEGORIES(state, payload) {
    state.subcategories = payload
  },
  SET_FIRST_LEVEL_CATEGORY(state, payload) {
    state.firstLevelCategory = payload
  },
}
